import React from "react";
import k from "@utils/keys";
import { Loader } from "semantic-ui-react";
import { IBiometryData, TBioResponse } from "@store/reducers";

class CallbackPage extends React.Component {
  constructor(props: any) {
    super(props);
    this.postMessage();
  }

  componentDidMount() {
    console.log("CallbackPage received Params: " + window.location.search);
  }

  postMessage() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const date = urlSearchParams.get("date") as string;
    const response = Number.parseInt(
      urlSearchParams.get("response") as string
    ) as TBioResponse;
    const message = urlSearchParams.get("message") as string;
    const card = urlSearchParams.get("card") as string;
    const biodocParams: IBiometryData = {
      date,
      response,
      message,
      card,
    };
    const json = JSON.stringify(biodocParams);
    console.log(json);
    parent?.window?.postMessage(json, k.BIOMETRIA.ORIGIN);
    this.state = { ...biodocParams };
  }

  render = () => {
    return <Loader active/>;
  };
}

export default CallbackPage;
